import React from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import cx from 'classnames';
import { useFormikContext } from 'formik';
import { Col, ControlLabel, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import FieldInput from '@magoosh/lib/formik_inputs/field_input';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import style from '@payments/style.module.scss';

const FIELD_OPTIONS = {
  style: {
    base: {
      color: '#4e4b50',
      fontFamily: '"Tondo", Arial, "Helvetica Neue", Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '1.5',
      fontSmoothing: 'antialiased'
    }
  }
};

const StripeCardInputs: React.FC<{}> = () => {
  const errors = useFormikContext().errors as any;

  return (
    <>
      <FieldInput
        name="cardName"
        type="input"
        label="Full Name"
      />
      <Row>
        <Col md={6}>
          <div className={cx(style.fullWidthOnMobile, { 'has-error': !!errors.stripeCardNumber })}>
            <div className="d-flex align-items-center">
              <div>
                <ControlLabel>Card Number</ControlLabel>
              </div>

              <div className="d-flex flex-1 justify-content-end" style={{ gap: 2, fontSize: 24 }}>
                <div className="fa fa-cc-visa" />
                <div className="fa fa-cc-mastercard" />
                <div className="fa fa-cc-discover" />
                <div className="fa fa-cc-amex" />
              </div>
            </div>
            <CardNumberElement options={FIELD_OPTIONS} className="form-control" />
            {
              errors.stripeCardNumber && (
                <div className="text-danger">
                  <small>{errors.stripeCardNumber}</small>
                </div>
              )
            }
          </div>
        </Col>

        <Col md={3}>
          <div className={cx(style.marginTopOnMobile, { 'has-error': !!errors.stripeExpirationDate })}>
            <ControlLabel>Expiration</ControlLabel>
            <CardExpiryElement
              options={FIELD_OPTIONS}
              className={cx(style.fullWidthOnMobile, 'form-control')}
            />
            {
              errors.stripeExpirationDate && (
                <div className="text-danger">
                  <small>{errors.stripeExpirationDate}</small>
                </div>
              )
            }
          </div>
        </Col>

        <Col md={3}>
          <div className={cx(style.marginTopOnMobile, { 'has-error': !!errors.stripeSecurityCode })}>
            <ControlLabel>
              CVC

              <OverlayTrigger
                overlay={<Tooltip>3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front.</Tooltip>}
              >
                <span className="u-margin-L-xxs">
                  <FontAwesomeIcon icon="question-circle" />
                </span>
              </OverlayTrigger>

            </ControlLabel>
            <CardCvcElement options={FIELD_OPTIONS} className={cx(style.fullWidthOnMobile, 'form-control')} />
            {
              errors.stripeSecurityCode && (
                <div className="text-danger">
                  <small>{errors.stripeSecurityCode}</small>
                </div>
              )
            }
          </div>
        </Col>
      </Row>
    </>
  );
};

export default StripeCardInputs;
